export class ConstantRegEx {
    public static readonly CURRENCY: RegExp = /^[0-9]{1,10}(\.[0-9]{0,2})?$/;
    public static readonly PERCENTAGE: RegExp = /^(?:0\.\d+|[1-9]\d*(?:\.\d+)?)$/;
    public static readonly EMPTYVALUE: RegExp = /^(?!\s*$)/;
}